import type { ResumeData } from "./index";

export const sampleResume: ResumeData = {
  basics: {
    name: "张三",
    headline: "富有创意和创新精神的Web开发工程师",
    email: "zhangsan@gmail.com",
    phone: "(555) 123-4567",
    gender: "male",
    location: "北京市朝阳区 100000",
    url: {
      label: "",
      href: "https://zhangsan.me/",
    },
    customFields: [],
    picture: {
      url: "https://ts1.tc.mm.bing.net/th/id/OIP-C.VGdddN8yMRqf_FtfDggPcgHaLH?w=149&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.5&pid=3.1&rm=2",
      size: 120,
      aspectRatio: 1,
      borderRadius: 0,
      effects: {
        hidden: false,
        border: false,
        grayscale: false,
      },
    },
  },
  sections: {
    summary: {
      name: "个人简介",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "summary",
      content:
        "<p>具有5年经验的创新型Web开发工程师，专注于构建有影响力且用户友好的网站和应用程序。专精于<strong>前端技术</strong>，热衷于现代Web标准和前沿开发技术。在从概念到部署的成功项目领导方面拥有良好的记录。</p>",
    },
    awards: {
      name: "获奖情况",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "awards",
      items: [],
    },
    certifications: {
      name: "认证证书",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "certifications",
      items: [
        {
          id: "spdhh9rrqi1gvj0yqnbqunlo",
          visible: true,
          name: "全栈Web开发",
          issuer: "编程学院",
          date: "2020",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
        {
          id: "n838rddyqv47zexn6cxauwqp",
          visible: true,
          name: "AWS认证开发者",
          issuer: "亚马逊云服务",
          date: "2019",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    education: {
      name: "教育经历",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "education",
      items: [
        {
          id: "yo3p200zo45c6cdqc6a2vtt3",
          visible: true,
          institution: "北京大学",
          studyType: "计算机科学学士",
          area: "北京",
          score: "",
          date: "2012年8月至2016年5月",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    experience: {
      name: "工作经历",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "experience",
      items: [
        {
          id: "lhw25d7gf32wgdfpsktf6e0x",
          visible: true,
          company: "创新解决方案有限公司",
          position: "高级Web开发工程师",
          location: "北京",
          date: "2019年1月至今",
          summary:
            "<ul><li><p>主导主要产品网站的重新设计，用户参与度提升40%。</p></li><li><p>开发并实施新的响应式框架，改善跨设备兼容性。</p></li><li><p>指导四名初级开发人员团队，培养技术卓越文化。</p></li></ul>",
          url: {
            label: "",
            href: "https://creativesolutions.inc/",
          },
        },
        {
          id: "r6543lil53ntrxmvel53gbtm",
          visible: true,
          company: "科技先锋公司",
          position: "Web开发工程师",
          location: "上海",
          date: "2016年6月至2018年12月",
          summary:
            "<ul><li><p>在10人团队中协作，使用React.js和Node.js开发高质量Web应用程序。</p></li><li><p>管理第三方服务集成，如Stripe支付和Twilio短信服务。</p></li><li><p>优化应用程序性能，实现加载时间减少30%。</p></li></ul>",
          url: {
            label: "",
            href: "https://techadvancers.com/",
          },
        },
      ],
    },
    volunteer: {
      name: "实习经历",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "volunteer",
      items: [],
    },
    interests: {
      name: "兴趣爱好",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "interests",
      items: [],
    },
    languages: {
      name: "语言能力",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "languages",
      items: [],
    },
    profiles: {
      name: "社交档案",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "profiles",
      items: [
        {
          id: "cnbk5f0aeqvhx69ebk7hktwd",
          visible: true,
          network: "领英",
          username: "zhangsan",
          icon: "linkedin",
          url: {
            label: "",
            href: "https://linkedin.com/in/zhangsan",
          },
        },
        {
          id: "ukl0uecvzkgm27mlye0wazlb",
          visible: true,
          network: "GitHub",
          username: "zhangsan",
          icon: "github",
          url: {
            label: "",
            href: "https://github.com/zhangsan",
          },
        },
      ],
    },
    projects: {
      name: "项目经历",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "projects",
      items: [
        {
          id: "yw843emozcth8s1ubi1ubvlf",
          visible: true,
          name: "电商平台",
          description: "项目负责人",
          date: "",
          summary:
            "<p>主导开发全栈电商平台，销售转化率提升25%。</p>",
          keywords: [],
          url: {
            label: "",
            href: "",
          },
        },
        {
          id: "ncxgdjjky54gh59iz2t1xi1v",
          visible: true,
          name: "交互式仪表板",
          description: "前端开发工程师",
          date: "",
          summary:
            "<p>为SaaS应用程序创建交互式分析仪表板，增强客户数据可视化体验。</p>",
          keywords: [],
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    publications: {
      name: "发表作品",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "publications",
      items: [],
    },
    references: {
      name: "推荐人",
      columns: 1,
      separateLinks: true,
      visible: false,
      id: "references",
      items: [
        {
          id: "f2sv5z0cce6ztjl87yuk8fak",
          visible: true,
          name: "可根据要求提供",
          description: "",
          summary: "",
          url: {
            label: "",
            href: "",
          },
        },
      ],
    },
    skills: {
      name: "专业技能",
      columns: 1,
      separateLinks: true,
      visible: true,
      id: "skills",
      items: [
        {
          id: "hn0keriukh6c0ojktl9gsgjm",
          visible: true,
          name: "Web技术",
          description: "精通",
          level: 0,
          keywords: ["HTML5", "JavaScript", "PHP", "Python"],
        },
        {
          id: "r8c3y47vykausqrgmzwg5pur",
          visible: true,
          name: "Web框架",
          description: "熟练",
          level: 0,
          keywords: ["React.js", "Angular", "Vue.js", "Laravel", "Django"],
        },
        {
          id: "b5l75aseexqv17quvqgh73fe",
          visible: true,
          name: "开发工具",
          description: "熟练",
          level: 0,
          keywords: ["Webpack", "Git", "Jenkins", "Docker", "JIRA"],
        },
      ],
    },
    custom: {},
  },
  metadata: {
    template: "glalie",
    layout: [
      [
        ["summary", "experience", "education", "projects", "references"],
        [
          "profiles",
          "skills",
          "certifications",
          "interests",
          "languages",
          "awards",
          "volunteer",
          "publications",
        ],
      ],
    ],
    css: {
      value: "* {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}",
      visible: false,
    },
    page: {
      margin: 14,
      format: "a4",
      options: {
        breakLine: true,
        pageNumbers: true,
      },
    },
    theme: {
      background: "#ffffff",
      text: "#000000",
      primary: "#ca8a04",
    },
    typography: {
      font: {
        family: "Merriweather",
        subset: "latin",
        variants: ["regular"],
        size: 13,
      },
      lineHeight: 1.75,
      hideIcons: false,
      underlineLinks: true,
    },
    notes: "",
  },
};
